import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const getPushUpOptionsRequest = createAction("".concat(stateName, "/getPushUpOptionsRequest"));
export const startCheckout = createAction("".concat(stateName, "/startCheckout"));
export const startCheckoutReview = createAction("".concat(stateName, "/startCheckoutReview"));
export const getPushUpMinimumPriceRequest = createAction("".concat(stateName, "/getPushUpMinimumPriceRequest"));
export const getPushUpMinimumPriceFailure = createAction("".concat(stateName, "/getPushUpMinimumPriceFailure"));